export default {"src":"/_next/static/media/slide-customizable-icon.7ac35950.svg","height":80,"width":76};